// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3jzOy","productName":"Table_productName__3yGxx"};